import React from 'react';
import { OptionPill } from './QuestionOption';
import TextDir from '../lib/TextDir';
import { useTranslation } from 'react-i18next';
import { IconExternalLink } from '@spotify-internal/encore-web/core/components/Icon/icons/IconExternalLink';
export const LinkOption = ({ title, value }) => {
    const { i18n } = useTranslation();
    return (React.createElement(OptionPill, { size: "small", onClick: () => window.open(value, '_blank'), "data-testid": "link-option" },
        React.createElement(TextDir, { locale: i18n.language }, title),
        React.createElement(IconExternalLink, { size: "xsmall", style: {
                marginLeft: '10px',
            } })));
};
//# sourceMappingURL=LinkOption.js.map